function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
//Material imports
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import withStyles from "@mui/styles/withStyles";
class HoverDetails extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleToggle", () => {
      this.setState(state => ({
        open: !state.open
      }));
    });
    _defineProperty(this, "handleClose", event => {
      if (this.anchorEl.contains(event.target)) {
        return;
      }
      this.setState({
        open: false
      });
    });
    this.anchorEl = /*#__PURE__*/React.createRef();
    this.state = {
      open: false
    };
  }
  render() {
    const {
      classes,
      renderItem,
      renderHoverDetails,
      title,
      value,
      centerLabel,
      buttonStyle
    } = this.props;
    const {
      open
    } = this.state;
    return (
      /*#__PURE__*/
      // Popper dosen't render if a value contains multiple lines
      // Keyboard is important for users with physical disabilities who cannot use a mouse, AT compatibility, and screenreader users.
      React.createElement("div", {
        onMouseOver: this.handleToggle,
        onMouseOut: this.handleToggle,
        onFocus: this.handleToggle,
        onBlur: this.handleToggle
      }, /*#__PURE__*/React.createElement(Button, {
        ref: node => {
          this.anchorEl = node;
        },
        classes: {
          root: classes.buttonRoot,
          text: centerLabel ? classes.centerButtonLabel : classes.buttonLabel
        },
        style: buttonStyle
      }, renderItem()), /*#__PURE__*/React.createElement(Popper, {
        open: open,
        anchorEl: this.anchorEl,
        transition: true,
        className: classes.popper
      }, ({
        TransitionProps,
        placement
      }) => /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
        id: "menu-list-grow",
        style: {
          transformOrigin: placement === "bottom" ? "center top" : "center bottom"
        }
      }), /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(ClickAwayListener, {
        onClickAway: this.handleClose
      }, renderHoverDetails ? renderHoverDetails() : /*#__PURE__*/React.createElement("div", {
        className: classes.contentWrapper
      }, /*#__PURE__*/React.createElement(Typography, {
        color: "primary",
        align: "center"
      }, title), /*#__PURE__*/React.createElement(Divider, {
        className: classes.divider
      }), /*#__PURE__*/React.createElement(Typography, {
        className: classes.valueText
      }, value)))))))
    );
  }
}
const styles = theme => ({
  buttonRoot: {
    padding: 0,
    minHeight: "unset",
    borderRadius: 0,
    height: "100%",
    display: "flex",
    width: "100%"
  },
  centerButtonLabel: {
    justifyContent: "center",
    color: theme.palette.primary.main
  },
  buttonLabel: {
    justifyContent: "flex-start",
    textAlign: "left",
    color: theme.palette.primary.dark
  },
  popper: {
    zIndex: 3000
  },
  paper: {
    maxWidth: 300
  },
  divider: {
    marginTop: 8,
    marginBottom: 8
  },
  contentWrapper: {
    padding: 16
  },
  valueText: {
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere"
  }
});
export default withStyles(styles)(HoverDetails);
HoverDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  renderItem: PropTypes.func.isRequired,
  renderHoverDetails: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.string,
  centerLabel: PropTypes.bool,
  buttonStyle: PropTypes.object
};
HoverDetails.defaultProps = {
  centerLabel: false
};